// extracted by mini-css-extract-plugin
export default {"melodyVideo":"qK-z","isFullWidth":"rK-z","landingPageVideo":"sK-z","play":"tK-z","iframeVideo":"uK-z","playHidden":"vK-z","fullwidth":"wK-z"};